import React, { useRef, useState, useCallback, useEffect } from 'react'

import {
    Box,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Card,
    styled,
    Button
} from '@mui/material';

import { useNavigate, Link } from 'react-router-dom';

// import DateFilter from '@inovua/reactdatagrid-community/DateFilter'

import CommonBreadcumbs from "../common/CommonBreadcumbs"
import DataGridToolbar from '../common/DataGridToolbar';
import DataGridTable from '../common/DataGridTable';
import CommonRestricted from '../common/CommonRestricted';
// import DataGridRowActionMenu from '../common/DataGridRowActionMenu';

import { icons } from '../common/CommonIcons';
// import { useCustomFields, customFieldModules, customFieldFunctions } from '../../hooks/api/useCustomFields';
// import { useInjectionProps, propTypes as injectionPropTypes, targetTypes as injectionPropTargetTypes } from '../../hooks/api/useInjectionProps';
import { useInjectionFields, injectionFieldTypes } from '../../hooks/api/useInjectionFields';
import { useSystemPrompt } from '../../hooks/useSystemPrompt';
import { useDataGridParams } from '../../hooks/useDataGridParams';
import { useSystemRoutes, routeTypes } from '../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../hooks/usePermissions';
import { useTranslations } from "../../hooks/useTranslations";

// const StyledCard = styled(Card)(({ theme }) => ({
//     padding: theme.spacing(2)
// }));

const RenderToolbar = ({ selectedIds, handleAdd, handleDelete, isPermissionAllow }) => {

    const getToolbarMainMenus = () => {

        let props = [];

        if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
            props.push({
                displayIconName: icons.plus,
                onClick: handleAdd
            })
        }

        return props
    }

    const getActionOnClick = () => {

        let handleFunction = null

        if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
            handleFunction = handleDelete
        }

        return handleFunction
    }

    return (
        <DataGridToolbar
            selectedRowCount={
                selectedIds.length
            }
            mainMenus={
                getToolbarMainMenus()
            }
            actionOnClickRemove={
                getActionOnClick()
            }
            actionMenus={[]}
        />
    )
}

export default function ListInjectionFields({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@injectionProp", "@injectionField", "prompt"] })

    const navigate = useNavigate();

    const { promptMessage } = useSystemPrompt();
    const { list, remove } = useInjectionFields({ injectionFieldType: injectionFieldTypes.injectionFields });

    const [selectedIds, setSelectedIds] = useState([])
    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const { defineColumns, columns, filterValues } = useDataGridParams('id')
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.injectionField.id, scopeTypes[scopeIds.injectionField.id].injectionField.id)

    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    // const [selectedFieldType, setSelectedFieldType] = useState("")
    // const [selectedFieldType1, setSelectedFieldType1] = useState("")
    // const [selectedFieldType2, setSelectedFieldType2] = useState("")

    // const [currentData, setCurrentData] = useState([])

    const gridRef = React.createRef();

    // const resetDataGridTableSelection = () => {
    //     setSelectedIds([])
    // }

    const fetchData = async (props) => {

        // must check use key
        // if (!selectedFieldType) {
        //     return {
        //         data: [],
        //         count: 0
        //     }
        // }

        // console.log('sdfsdfds')
        // resetDataGridTableSelection();

        try {

            // if (!props?.sortInfo) props.sortInfo = {
            //     id: "type",
            //     dir: 0,
            // }

            // props.targetType = selectedFieldType

            const result = await list(props)

            return {
                data: result?.data?.injection_fields,
                count: result?.data?.total
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }

    }

    useEffect(() => {

        defineColumnsView()

    }, [])

    const defineColumnsView = () => {
        defineColumns([
            {
                name: 'field_module',
                header: t('module'),
                defaultFlex: 0,
                defaultWidth: 130,
                renderValue: ({ value, cellProps }) => {

                    // if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) === false) {
                    //     return getRenderColumnTextDisplay(value)
                    // }

                    // let path = getRoute(`injectionProp/update/${cellProps.data.id}`);

                    // return getRenderColumnLink(path, value)

                    return value

                }
            },
            {
                name: 'field_ref',
                header: t('reference'),
                defaultFlex: 0,
                defaultWidth: 130,
            },
            {
                name: 'field_type',
                header: t('fieldType'),
                defaultFlex: 0,
                defaultWidth: 130,
            },
            {
                name: 'field_key',
                header: t('fieldKey'),
                defaultFlex: 0,
                defaultWidth: 300,
            },
        ])
    }

    // const handleOnSubmit = () => {

    //     let useKey = ''

    //     if (selectedFieldType1) useKey = (selectedFieldType1)
    //     if (selectedFieldType2) useKey = (selectedFieldType2)

    //     if (!useKey) {
    //         promptMessage(false, t('pleaseSelectAtLeastAnyProperty'))
    //         return false
    //     }

    //     setRefreshDataGrid(refreshDataGrid + 1)
    //     setSelectedFieldType(useKey)
    //     return true

    // }

    const handleDelete = async () => {

        try {

            // let keys = [];
            // let fieldModule = '';
            // let fieldRef = '';

            // // find back the key from id
            // selectedIds.forEach((i, index) => {

            //     const a = currentData.filter(i2 => i2.id === (i))

            //     console.log('currentData', currentData, i)

            //     if (a.length) {
            //         keys.push(a[0]?.type)
            //         fieldModule = a[0]?.field_module
            //         fieldRef = a[0]?.field_ref
            //     }
            // })

            // // console.log('keys, keys', keys)

            // let data = {
            //     field_module: fieldModule,
            //     field_ref: fieldRef,
            //     keys
            // }

            // if (keys.length <= 0) {
            //     promptMessage(false, `Invalid Keys`)
            //     return false
            // }

            let data = {
                ids: selectedIds
            }

            // let result = await remove({ data, propType: selectedFieldType })
            let result = await remove({ data })

            promptMessage(true, result?.message)
            setRefreshDataGrid(val => val + 1)

        } catch (error) {
            promptMessage(false, error?.message)
        }

        return true

    }

    // const RenderFilters = () => {

    //     // get the inner props
    //     let selectMainPropertyId = selectedFieldType1

    //     let innerProperties = []

    //     if (selectMainPropertyId) {
    //         Object.keys(fieldTypes[selectMainPropertyId]).forEach(i => {
    //             innerProperties.push(fieldTypes[selectMainPropertyId][i])
    //         })
    //     }

    //     let mainTargetTypes = Object.keys(injectionFieldTargetTypes).filter(i => injectionFieldTargetTypes[i].isMain === true)

    //     return (
    //         <StyledCard>
    //             <Grid container spacing={2}>
    //                 <Grid item xs={10} md={10} sm={10}>
    //                     <FormControl
    //                         margin="dense"
    //                         fullWidth
    //                         size="small"
    //                     // error={touched.branchAccessId && Boolean(errors.branchAccessId)}
    //                     >
    //                         <InputLabel id="branch">{t("mainProperty")}</InputLabel>
    //                         <Select
    //                             fullWidth
    //                             // labelId="branchAccessId"
    //                             label="Main Property"
    //                             // name={"branchAccessId"}
    //                             onChange={(e) => setSelectedFieldType1(e.target.value)}
    //                             value={selectedFieldType1}
    //                         >
    //                             {
    //                                 mainTargetTypes.map((i, index) => {

    //                                     let description = injectionFieldTargetTypes[i].description

    //                                     return (
    //                                         <MenuItem
    //                                             key={index}
    //                                             value={i}
    //                                         >
    //                                             {/* <Checkbox checked={values.branchAccessId.indexOf(i.id) > -1} /> */}
    //                                             {/* <ListItemText primary={`${i.branch_name} (${i.branch_code})`} /> */}
    //                                             {`${i} - ${description}`}
    //                                         </MenuItem>
    //                                     )
    //                                 })
    //                             }
    //                         </Select>
    //                         {/* <FormHelperText>
    //                                 {touched.branchAccessId && errors.branchAccessId}
    //                             </FormHelperText> */}
    //                     </FormControl>
    //                 </Grid>
    //                 {/* <Grid item xs={5} md={5} sm={5}> */}
    //                 {/* <FormControl
    //                         margin="dense"
    //                         fullWidth
    //                         size="small"
    //                     // error={touched.branchAccessId && Boolean(errors.branchAccessId)}
    //                     >
    //                         <InputLabel id="branch">Inner Property</InputLabel>
    //                         <Select
    //                             fullWidth
    //                             // labelId="branchAccessId"
    //                             label="Inner Property"
    //                             // name={"branchAccessId"}
    //                             onChange={(e) => setSelectedFieldType2(e.target.value)}
    //                             value={selectedFieldType2}
    //                         >
    //                             {
    //                                 innerProperties.map((i, index) => {
    //                                     return (
    //                                         <MenuItem
    //                                             key={index}
    //                                             value={i?.key}
    //                                         >
    //                                             {i?.id}
    //                                         </MenuItem>
    //                                     )
    //                                 })
    //                             }
    //                         </Select>
    //                     </FormControl> */}
    //                 <></>
    //                 {/* </Grid> */}

    //                 <Grid item xs={2} md={2} sm={2} display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"flex-end"}>

    //                     <Button
    //                         variant='contained'
    //                         color='primary'
    //                         fullWidth
    //                         type='button'
    //                         onClick={handleOnSubmit}
    //                     >
    //                         {t('browseProps')}
    //                     </Button>

    //                 </Grid>
    //             </Grid>
    //         </StyledCard>
    //     )
    // }

    const handleAdd = () => {
        navigate(getRoute("settings/injectionField/new"));
    }

    const handleSelectionChange = (items) => {
        // console.log('item,s', items)
        setSelectedIds(items)
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.injectionFields })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t('injectionFields')}
                // pageSubTitle="customers in your system"
                breadcrumbs={[
                    {
                        displayText: t("injectionFields"),
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    (
                        <>
                            <RenderToolbar
                                selectedIds={selectedIds}
                                handleAdd={handleAdd}
                                handleDelete={handleDelete}
                                isPermissionAllow={isPermissionAllow}
                            />
                            <DataGridTable
                                ref={gridRef}
                                refresh={refreshDataGrid}
                                fetchData={fetchData}
                                dataGrid={{
                                    idProperty: "id",
                                    style: {
                                        minHeight: 600
                                    },
                                    pageSizes: [20, 50, 100],
                                    defaultLimit: 10,
                                    defaultSkip: 0,
                                    checkboxColumn:
                                        isPermissionAllow({ functionType: functionTypes.remove.id }),
                                    columns,
                                    defaultFilterValue: filterValues,
                                    onSelectionChange: handleSelectionChange
                                }}

                            />
                        </>
                    )
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}
